import { ListImagesSkeletonComponent } from './list-images-skeleton.component';

export default angular
  .module('sfMobile.components.list-images-skeleton', [])
  .component('sfListImagesSkeleton', ListImagesSkeletonComponent).name;
